var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.67062L8.75313 1.38906C9.25938 0.528437 10.1844 0 11.1812 0H11.25C12.7688 0 14 1.23125 14 2.75C14 3.2 13.8906 3.59687 13.7 4H14.5C15.3281 4 16 4.67188 16 5.5V7.5C16 8.15312 15.5813 8.70937 15 8.91562V14C15 15.1031 14.1031 16 13 16H3C1.89531 16 1 15.1031 1 14V8.91562C0.4175 8.70937 0 8.15312 0 7.5V5.5C0 4.67188 0.671562 4 1.5 4H2.3C2.10812 3.59687 2 3.2 2 2.75C2 1.23125 3.23125 0 4.75 0H4.81875C5.81562 0 6.74062 0.528437 7.24687 1.38906L8 2.67062ZM9 5.5V7.5H14.5V5.5H9ZM7 5.5H1.5V7.5H7V5.5ZM7 9H2.5V14C2.5 14.275 2.72375 14.5 3 14.5H7V9ZM9 14.5H13C13.275 14.5 13.5 14.275 13.5 14V9H9V14.5ZM11.25 4C11.9406 4 12.5 3.44062 12.5 2.75C12.5 2.05969 11.9406 1.5 11.25 1.5H11.1812C10.7156 1.5 10.2844 1.74719 10.0469 2.14937L8.95938 4H11.25ZM7.04063 4L5.95312 2.14937C5.71562 1.74719 5.28437 1.5 4.81875 1.5H4.75C4.05937 1.5 3.5 2.05969 3.5 2.75C3.5 3.44062 4.05937 4 4.75 4H7.04063Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.36f2007315f9903817b1f2289f6a5952.svg";
export { ForwardRef as ReactComponent };